import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import "../api";
import "selectize";

"use strict";

class ProtectedSection {
    constructor() {
        this._locked = false;
    }

    then(fn) {
        if (this._locked) {
            return false;
        }
        this._locked = true;
        try {
            return fn();
        } finally {
            this._locked = false;
        }
    }
}


function updateDetailedValue(presentationObs, val, newitems, requires_id) {
    /**
     * The following updates the presentation (observable showing deatils of selected value)
     **/
    var presentation = ko.unwrap(presentationObs);
    if (presentation && presentation.typeof("Array") && val && val.typeof("Array")) {
        if (requires_id) {
            var tmp = [];
            $.each(val, function () {
                tmp.push({
                    id: this
                });
            });
            presentationObs(tmp);
        } else presentationObs(val);
    } else if (presentation && presentation.typeof("Object")) {
        var d = null;
        if (val) {
            d = newitems;
        } else {
            d = {};
            $.map(presentation, function (val, key) {
                d[key] = null;
                return null;
            });
        }

        if (d) {
            for (var p in presentation) {
                if (p in d) {
                    if (ko.isObservable(presentation[p])) {
                        presentation[p](d[p]);
                    } else {
                        presentation[p] = d[p];
                    }
                }
            }
        }
    }
}

function updateLookupValue(lookupValueObs, val, requires_id) {
    var stored = ko.unwrap(lookupValueObs);
    if ((stored == null || (stored && stored.typeof("Array"))) && val && val.typeof("Array")) {
        if (requires_id) {
            var tmp = [];
            $.each(val, function () {
                tmp.push({
                    id: this
                });
            });
            lookupValueObs(tmp);
        } else lookupValueObs(val);
    } else {
        if (typeof val !== "undefined")
            lookupValueObs(val !== "" ? val : null);
    }
}

/// Create the selectize machinery to display a (maybe) dynamic list of options and the current value
/// $elt: The select element
/// lookupValueObs: observable containing the current value (id)
/// lookupPresentationObj: observable containing the current displayed text
/// requires_id: uh?
/// s2_options: extra options for selectize
/// events: possible on change event callback
function _create_dropdown($elt, lookupValueObs, lookupPresentationObs, currentOptionsObs, requires_id, s2_options, events) {

    /// we want to create an understandable data flow.
    /// inputs are:
    ///    lookupValueObs, lookupPresentationObs, filters
    /// outputs are:
    ///     lookupValueObs, lookupPresentationObs

    var onchange = null;
    if (events) {
        onchange = events.onchange;
    }

    var lookupModel = {
        value: null,
        presentation: null,
        options: null,
        changing: new ProtectedSection(),
        multiple: ko.pureComputed(() => { return $elt.attr("multiple"); }),
    }

    var selectize_options = {
        hideSelected: true,
        closeAfterSelect: ko.unwrap(lookupModel.multiple) != true
    };

    if (s2_options) {
        $.extend(selectize_options, s2_options);
    }

    if (ko.isObservable(lookupValueObs)) {
        lookupModel.value = lookupValueObs
    } else {
        lookupModel.value = ko.observable(ko.unwrap(lookupValueObs));
    }

    if (ko.isObservable(lookupPresentationObs)) {
        lookupModel.presentation = lookupPresentationObs;
    } else {
        lookupModel.presentation = ko.observable(ko.unwrap(lookupPresentationObs));
    }

    if (currentOptionsObs) {
        lookupModel.options = currentOptionsObs;
        delete selectize_options.load;
    }

    selectize_options.onChange = function (newvalue) {
        lookupModel.changing.then(()=> {
            var newitems = null;
            var self = this;
            if (!lookupModel.multiple() && newvalue) {
                newitems = this.options[newvalue];
            } else if (lookupModel.multiple() && newvalue) {
                newitems = newvalue.map(function (v) {
                    return self.options[v];
                });
            }

            updateLookupValue(lookupModel.value, newvalue, requires_id);
            updateDetailedValue(lookupModel.presentation, newvalue, newitems, requires_id);
            if (onchange) {
                onchange(lookupModel.value, lookupModel.presentation, newvalue, newitems);
            }

        });

        
        if ($elt.valid) $elt.valid();
    };

    var $s2 = $elt.selectize(selectize_options);
    var selectizer = $s2[0].selectize;
    $s2.on("change", function () {
        if ($elt.valid) {
            $elt.valid();
        }
    });

    if (lookupModel.options) {
        var refreshItems = (newvalues) => {
            var value = ko.unwrap(lookupModel.value);
            if (typeof newvalues.results !== "undefined") {
                newvalues = newvalues.results;
            }
            selectizer.clearOptions();
            selectizer.addOption(newvalues || []);
            selectizer.refreshOptions(false);
            if (lookupModel.multiple()) {
                var items = [];
                (value || []).forEach((v) => {
                    if (v && ko.unwrap(v.id) ) {
                        var o = selectizer.options[ko.unwrap(v.id)];
                        if (o)
                            items.push(o);
                    } else {
                        var o = selectizer.options[v];
                        if (o)
                            items.push(o);
                    }
                });
                selectizer.clear(true);
                items.forEach((i)=>{selectizer.addItem(ko.unwrap(i.id), true);});
                lookupModel.changing.then(()=>{
                    selectizer.refreshItems();
                });
            } else {
                selectizer.setValue(value, true);
            }
            if ($elt.valid) $elt.valid();
        }
        if (ko.isObservable(lookupModel.options)) {
            lookupModel.options.subscribe((newvalues) => {
                lookupModel.changing.then(() => {
                    refreshItems(newvalues);
                });
            });
        }
        refreshItems(ko.unwrap(lookupModel.options) || []);
    }

    var loaded = false;
    return $elt;
}

function flatten_node(i, depth, flat_array) {
    i.depth = depth;
    flat_array.push(i);
    i.children.forEach(function (ii) {
        flatten_node(ii, depth + 1, flat_array);
    });
}

function process_hierarchy(res) {
    //order hierarchically, add depth, and icon identation
    var items = res.items;
    var itemdic = {};
    var roots = [];
    items.forEach(function (i) {
        itemdic[i.id] = i;
        i.children = [];
    });
    items.forEach(function (i) {
        if (i.parent && itemdic[i.parent]) {
            var p = itemdic[i.parent];
            p.children.push(i);
        } else {
            roots.push(i);
        }
    });
    var results = [];
    roots.forEach(function (r) {
        flatten_node(r, 0, results);
    });
    return {
        items: results
    };
}

var lookup_cache = {

};
var cache_last_cleaned = Date.now();
function clean_cache() {
    var now = Date.now();
    if (cache_last_cleaned > now - 60000) {
        return;
    }
    cache_last_cleaned = now;
    for (var key in lookup_cache) {
        if (lookup_cache.dt < now - 300000) {
            delete lookup_cache[key];
        }
    }
}

function load_lookup(classification, filters, hierarchy, cachekey, alt) {
    clean_cache();
    var lk_params = $.extend({
        "model": classification
    }, filters || {});
    if (cachekey) {
        lk_params.q = $.extend({
            "cachekey": cachekey
        }, lk_params.q || {});
    }
    if (alt) {
        lk_params.alt = alt;
    }
    var lk_key = cachekey ? ko.toJSON(lk_params) : null;
    if (lk_key) {
        if (lookup_cache[lk_key] && lookup_cache[lk_key].dt > Date.now() - 300000) {
            return lookup_cache[lk_key].promise;
        }
    }
    var last_results = uly.api.start()
        .follow("uly:data")
        .follow("uly:lookup", lk_params);
    if (hierarchy) {
        last_results = last_results.then(process_hierarchy);
    }
    //We have a promise that will return a result. 
    //now wrap it in a deferred that can be cancelled
    var res = Promise.Deferred();

    last_results = last_results.then((tmp) => {
        console.log("Resolving:", classification, filters, res.state());
        res.resolve({
            "results": tmp.items.map(function (item) {
                item.text = item.title || item.name || item.key_code;
                return item;
            })
        });
    }, function(error) {
        console.log("Fetch Error:", classification, filters, error, res.state());
        res.reject(error);
    });
    res.fail((error) => {
        delete lookup_cache[lk_key];
    });
    if (lk_key) {
        lookup_cache[lk_key] = { promise: res, dt: Date.now() };
    }
    return res;
}

var last_lk_id = 0;

ko.bindingHandlers.lookup = {
    clear_cache: function() {
        lookup_cache = {};
    },
    init: function (elt, va, bindings, model, context) {
        var classification = ko.unwrap(va()),
            element = $(elt);
        var hierarchy = ko.unwrap(bindings().hierarchy);
        var cachekey = ko.unwrap(bindings().cachekey);
        var alt = ko.unwrap(bindings().alt);
        var filters_obs = ko.pureComputed(function () {
            return bindings().filters ?
                uly.utils.parse_filters(ko.unwrap(bindings().filters)) :
                {};
        });
        var multiple = $(elt).attr("multiple");
        var lookupOptions = ko.pureComputed(()=>{
            var filters = ko.unwrap(filters_obs);
            return load_lookup(classification, filters, hierarchy, cachekey, alt);
        }).extend({ async: [] });

        var onchange = ko.unwrap(bindings().onchange);
        var changeEvent = null;
        if (onchange) {
            changeEvent = function(obs, presObs, newvalue) {
                console.log("Lookup On change:", classification, newvalue);
                onchange(obs, newvalue, elt, context, model  )
            }
        }

        var $dropdown = _create_dropdown(element, bindings().lookupValue, bindings().lookupPresentation, lookupOptions, true, {
            render: {
                option: function (item, escape) {
                    var icon = item.icon || "fa-circle-thin";
                    if (item.colour) {
                        var cres = ko.bindingHandlers.colour.get_colour_class_and_style(item.colour, "text-", "fa " + icon);
                        var icon_txt = "<i class=\"" + cres["class"] + "\" ";
                        if (cres.style) {
                            icon_txt += "style=\"" + cres.style + "\"";
                        }
                        icon_txt += "></i> ";
                    } else {
                        icon_txt = "<i class=\"fa " + icon + "\"></i> ";
                    }
                    var prefix_txt = "";
                    if (item.depth) {
                        prefix_txt = new Array(item.depth + 1).join("<i class='fa fa-blank' ></i>");
                    }
                    return "<div>" + prefix_txt + icon_txt + escape(item.text) + "</div>";
                },
                item: function (item, escape) {
                    var icon = item.icon || "fa-circle-thin";
                    if (item.colour) {
                        var cres = ko.bindingHandlers.colour.get_colour_class_and_style(item.colour, "text-", "fa " + icon);
                        var icon_txt = "<i class=\"" + cres["class"] + "\" ";
                        if (cres.style) {
                            icon_txt += "style=\"" + cres.style + "\"";
                        }
                        icon_txt += "></i> ";
                    } else {
                        icon_txt = "<i class=\"fa " + icon + "\"></i> ";
                    }
                    return "<div data-value=\"" + item.id + "\">" + icon_txt + escape(item.text) + "</div>";
                }
            },
            preload: true,
            valueField: "id",
            labelField: "text",
            maxItems: multiple ? null : 1,
            closeAfterSelect: multiple ? false : true,
            plugins: ["remove_button"],
            hideSelected: hierarchy ? false : true
        }, 
        {
            onchange: changeEvent
        });
    }
};

ko.bindingHandlers.dynselect = {
    init: function (element, va, bindings, model, context) {
        var options = ko.toJS(bindings().dynoptions);
        var childContext = context.extend({
            "options": create_dyn_options_accessor(options)
        });
        var multiple = $(element).attr("multiple");
        console.log("dynselcet: got child context:", childContext);
        ko.applyBindingsToDescendants(childContext, element);
        _create_dropdown($(element), va(), null, childContext.options, true, {
            preload: true,
            valueField: "id",
            labelField: "caption",
            maxItems: multiple ? null : 1,
            closeAfterSelect: multiple ? false : true,
            plugins: ["remove_button"],
            hideSelected: true
        });
        return {
            "controlsDescendantBindings": true
        };
    },
    update: function (element, va) {
        //element.selectize.setValue(ko.unwrap(va()));
    }
};

function create_dyn_options_accessor(accessor) {
    var observable = ko.pureComputed(function () {
        var vals = [];
        var options = ko.unwrap(accessor);
        console.log("got options: ", options);
        $.each(options, function (idx, opt) {
            var nv = {};
            nv.id = opt.id ? opt.id : opt.key ? opt.key : idx;
            nv.caption = opt.title ? opt.title : opt.name ? opt.name : opt.value ? opt.value : opt.caption ? opt.caption : opt;
            vals.push(nv);
        });
        console.log("built vals:", vals);
        return vals;
    });
    return observable;
}

ko.bindingHandlers.select = {
    init: function (elt, va, bindings) {
        var value = ko.unwrap(va()),
            $elt = $(elt);
        if (value) {
            if (Array.isArray(value)){
                value.forEach((val, idx) => {
                    $.each($elt.children(), function () {
                        var $this = $(this);
                        if ($this.val() == val)
                            $this.attr({
                                "selected": "selected"
                            });
                    });
                });
            } else {
                $.each($elt.children(), function () {
                    var $this = $(this);
                    if ($this.val() == value)
                        $this.attr({
                            "selected": "selected"
                        });
                });
            }
        }
        _create_dropdown($(elt), va(), bindings().presentation);
    }
};

var KNOWN_COLOURS = ["aqua", "warning", "danger", "info", "primary", "success", "default",
    "jacksons-purple", "yellow-sea", "starship", "sienna", "tomato", "bahia",
    "apple", "java", "light-sea-green", "vista-blue", "hippie-blue",
    "breaker-bay", "teal-blue", "plum", "spray", "blue", "teal"
];
ko.bindingHandlers.colourpicker = {
    init: function (elt, va, bindings) {
        var colours = ko.pureComputed( () => {
            return { "results": KNOWN_COLOURS.map(function (val) {
                return {
                    "value": val,
                    "caption": val
                };
            })};
        });
        _create_dropdown($(elt), va(), bindings().presentation, colours, false, {
            render: {
                option: function (item, escape) {
                    return "<div><i class=\"fa fa-square text-" + escape(item.value) + "\"></i> " + escape(item.caption) + "</div>";
                },
                item: function (item, escape) {
                    return "<span><i class=\"fa fa-square text-" + escape(item.value) + "\"></i> " + escape(item.caption) + "</span>";
                }
            }
        });
    }
};

ko.bindingHandlers.currentStepSelector = {
    init: function (elt, va, bindings) {
        var current_steps = bindings().steps;
        var availableSteps = ko.pureComputed(()=> {
                var steps = ko.unwrap(current_steps) || [];
                var laststeps = ko.unwrap(bindings().laststeps) || [];
                steps = steps.map(function (val) {
                    return {
                        "caption": _("marketing_campaignstepselector_caption_description", "{0}: {1}").format(ko.unwrap(val.status.name), ko.unwrap(val.description)),
                        "icon": ko.unwrap(val.status.icon),
                        "value": ko.unwrap(val.status.id)
                    };
                }).concat(laststeps.map(function (val) {
                    return {
                        "caption": ko.unwrap(val.caption),
                        "icon": ko.unwrap(val.icon),
                        "value": ko.unwrap(val.id)
                    };
                }));

                var closed_step = steps.filter(function (s) {
                    return s.value === "";
                });
                if (!closed_step.length) {
                    steps.push({
                        "caption": _("marketing_campaignstepselector_closed_step", "Closed"),
                        "icon": "fa-check-square-o",
                        "value": ""
                    });
                }
                return { "results": steps };
        });
        var $dd = _create_dropdown($(elt), va(), bindings().presentation, availableSteps, false, {
            render: {
                option: function (item, escape) {
                    return "<div><i class=\"fa " + escape(item.icon) + "\"></i> " + escape(item.caption) + "</div>";
                },
                item: function (item, escape) {
                    return "<div><i class=\"fa " + escape(item.icon) + "\"></i> " + escape(item.caption) + "</div>";
                }
            }
        });
        /*
        if (ko.isObservable(current_steps)) {
            var sub = current_steps.subscribe(function (newvalue) {
                $dd[0].selectize.load(function (callback) {
                    callback((newvalue || []).map(function (val) {
                        return {
                            "caption": _("marketing_campaignstepselector_caption_description", "{0}: {1}").format(ko.unwrap(val.status.name), ko.unwrap(val.description)),
                            "icon": ko.unwrap(val.status.icon),
                            "value": ko.unwrap(val.status.id)
                        };
                    }));
                });
            });
            ko.utils.domNodeDisposal.addDisposeCallback(elt, function () {
                sub.dispose();
            });
        }
        */
    }
};

$(function () {
    $.validator.setDefaults({
        ignore: ":hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input",
        errorPlacement: function(error, element) {
            //go up max 3
            let container = element.closest(".error-container", element.parent().parent().parent());
            if (container.length) {
                error.appendTo(container);
            } else {
                error.insertAfter(element);
            }
        }
    });
});
